export class DocumentTemplateRole {
  id: number;
  document_template_role_name_id: number;
  document_template_id: number;
  template_class: string;
  template_name: string;
}
